module.exports = __webpack_public_path__ + "static/media/eng_d_2508.0db2cc70.mp4";